import React, { useState } from "react";
import { useQuote } from "../context/QuoteContext";
import { formatEur } from "../utils";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Switch } from "./ui/switch";
import { Label } from "./ui/label";
import { Plus, Minus, Package, ChevronDown } from "lucide-react";
import { Textarea } from "./ui/textarea";

export default function ImballaggioSection() {
  const { ritiro, setRitiro, imballaggioTotal, imballaggioMinutes } = useQuote();
  const [open, setOpen] = useState(true);
  const [manualCosto, setManualCosto] = useState("");
  const [manualMin, setManualMin] = useState("");

  const imb = ritiro.imballaggio || {};
  const upd = (patch) => setRitiro((r) => ({ ...r, imballaggio: { ...r.imballaggio, ...patch } }));

  return (
    <div className="bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden" data-testid="imballaggio-section">
      <div className="flex items-center justify-between p-6 pb-4">
        <div className="flex items-center gap-3">
          <Package className="h-5 w-5 text-[#1a5f5a]" />
          <h3 className="font-display font-semibold text-lg">Imballaggio</h3>
        </div>
        <div className="flex items-center gap-3">
          <Switch checked={!!imb.enabled} onCheckedChange={(v) => upd({ enabled: v })} data-testid="imballaggio-toggle" />
          <button onClick={() => setOpen(!open)} className="text-slate-400"><ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} /></button>
        </div>
      </div>

      {open && imb.enabled && (
        <div className="px-6 pb-6 space-y-4">
          <div className="grid grid-cols-2 gap-3 items-end">
            <div>
              <Label className="text-xs">Numero di persone</Label>
              <div className="flex items-center gap-2 mt-1">
                <Button size="icon" variant="outline" className="h-9 w-9" onClick={() => upd({ numPersone: Math.max(1, (imb.numPersone || 1) - 1) })}><Minus className="h-3.5 w-3.5" /></Button>
                <span className="w-8 text-center font-semibold" data-testid="imballaggio-persone">{imb.numPersone || 1}</span>
                <Button size="icon" variant="outline" className="h-9 w-9" onClick={() => upd({ numPersone: Math.min(5, (imb.numPersone || 1) + 1) })}><Plus className="h-3.5 w-3.5" /></Button>
              </div>
            </div>
            <div>
              <Label className="text-xs">Tariffa oraria (€)</Label>
              <Input type="number" value={imb.tariffaOraria ?? 25} onChange={(e) => upd({ tariffaOraria: parseFloat(e.target.value) || 0 })} className="mt-1" data-testid="imballaggio-tariffa-input" />
            </div>
          </div>

          <div className="bg-slate-50 rounded-md p-4 text-sm space-y-1">
            <div className="flex justify-between text-slate-500">
              <span>Tempo imballaggio {imb.isMinutiManual ? "(manuale)" : "(dagli oggetti)"}</span>
              <span>{imballaggioMinutes} min</span>
            </div>
            <div className="flex justify-between font-semibold text-slate-800 pt-2 border-t border-slate-200 mt-2">
              <span>Costo imballaggio</span>
              <span className="text-[#1a5f5a]" data-testid="imballaggio-total">€{formatEur(imballaggioTotal)}</span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 items-center">
            <Input type="number" placeholder="Minuti manuali" value={manualMin} onChange={(e) => setManualMin(e.target.value)} className="w-40 h-9" />
            <Button size="sm" variant="outline" onClick={() => upd({ isMinutiManual: true, minutiManuale: parseFloat(manualMin) || 0 })} data-testid="imballaggio-manual-min">Imposta minuti</Button>
            {imb.isMinutiManual && <Button size="sm" variant="ghost" className="text-slate-400" onClick={() => upd({ isMinutiManual: false, minutiManuale: null })}>Auto</Button>}
          </div>
          <div className="flex flex-wrap gap-2 items-center">
            <Input type="number" placeholder="Costo manuale €" value={manualCosto} onChange={(e) => setManualCosto(e.target.value)} className="w-40 h-9" />
            <Button size="sm" variant="outline" onClick={() => upd({ isCostoManual: true, costoManuale: parseFloat(manualCosto) || 0 })} data-testid="imballaggio-manual-cost">Imposta costo</Button>
            {imb.isCostoManual && <Button size="sm" variant="ghost" className="text-slate-400" onClick={() => upd({ isCostoManual: false, costoManuale: null })}>Auto</Button>}
          </div>

          <div>
            <Label className="text-xs">Nota / disclaimer (in corsivo nel messaggio)</Label>
            <Textarea value={imb.disclaimer ?? ""} onChange={(e) => upd({ disclaimer: e.target.value })}
              rows={3} className="mt-1 text-sm italic" data-testid="imballaggio-disclaimer-input" />
          </div>

          <p className="text-[11px] text-slate-400">
            Il tempo è calcolato dai minuti di imballaggio impostati su ogni oggetto (× quantità), considerando solo gli oggetti con "Includi" attivo. Se attiva, questa voce compare come riga separata nel messaggio WhatsApp.
          </p>
        </div>
      )}
    </div>
  );
}
